module.exports = __webpack_public_path__ + "assets/avatar-jayclick.ff1aa12f.svg";